import React, { Component } from 'react';
import ErrorAwareSelectField from './ErrorAwareSelectField';

class PaymentMethodFormControl extends Component {
    render() {
        return (
            <ErrorAwareSelectField
                labelId="payment-method-label"
                id="payment-method"
                name="selectedPaymentMethod"
                label="Fizetés módja"
                errors={this.props.errors}
                value={this.props.value}
                prevValue={this.props.prevValue}
                onChange={this.props.onChange}
                options={this.props.options}
                modify={this.props.modify}
            />
        )
    }
}
export default PaymentMethodFormControl;